import React, {useEffect,useState,useRef} from 'react';
import {Modal,Table,notification,Button,Row,Col,Input} from 'antd';
import {companyService} from '../../../services/company.services';
import { consignorService } from "../../../services/consignor.services";
import ModalGuarantorBeforeContract from "../guarantor-before-contract";
import Spinner from "../../spinner";
import { useHistory } from "react-router-dom";
import ModalCreateOrderToConsignor from "../create-order-to-consignor";
import ModalShipperCompanyFullInfo from "../shipper-company-full-info";
import ModalCreateContractOrder from "../create-contract-order";
import {userServices} from "../../../services";
import i18n from '../../../i18n';

export default function ModalListShipCompanies({isShow,setIsShow,legalEntityId,setIsShowParent = null}) {

    const [data, setData] = useState(null);
    const [needUpdate, setNeedUpdate] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [showShipperCompanyInfoModal, setShowShipperCompanyInfoModal] = useState(false);
    const [currentOrderId, setCurrentOrderId] = useState(null);
    const [loadingContentModal, setLoadingContentModal] = useState(false);

    // Постраничная навигация и поиск по названию грузоотправителя
    const [page, setPage] = useState(1);
    const perPage = 20;
    const [search, setSearch] = useState('');
    const [total, setTotal] = useState(0);
    const searchTimer = useRef(null);

    const [showOrderToConsignorModal, setShowOrderToConsignorModal] = useState(false);
    const [currentConsignorId, setCurrentConsignorId] = useState(false);

    const [showOrderToShipperCompanyModal, setShowOrderToShipperCompanyModal] = useState(false);
    const [currentShipperCompanyId, setCurrentShipperCompanyId] = useState(false);
    const [showGuarantorModal, setShowGuarantorModal] = useState(false);

    const [helpText, setHelpText] = useState(i18n.t('modals.modalListShipCompanies.helpText.1'));

    const history = useHistory();

    const handleSearchChange = (value) => {
        // Debounce: запрос на сервер выполняется через 400мс после прекращения ввода
        if (searchTimer.current) {
            clearTimeout(searchTimer.current);
        }
        searchTimer.current = setTimeout(() => {
            setPage(1);
            setSearch(value);
        }, 400);
    };

    useEffect(() => {
        if ((isShow || needUpdate) && legalEntityId !== null){
            setLoadingContentModal(true);
            setNeedUpdate(false);
            companyService
                .getShipperCompaniesList(legalEntityId, page, perPage, search)
                .then(resp => {
                    // Ответ может быть как в новом формате {list, total, page, perPage},
                    // так и в старом (плоский массив) — обрабатываем оба.
                    const respList = resp && resp.list ? resp.list : (resp || []);
                    if (resp && resp.total !== undefined) {
                        setTotal(resp.total);
                    }

                    let respData = [];
                    respList.forEach(element => {
                        if (element.ConsignorData.Order && element.ConsignorData.Order.Status.Id === 2) {
                            setHelpText(i18n.t('modals.modalListShipCompanies.helpText.2'));
                        }

                        respData.push({
                            'Id': element.ConsignorData.Id,
                            'Name': element.ConsignorData.Name,
                            'Order': element.ConsignorData.Order,
                            'IsOwner': element.ConsignorData.IsOwner,
                            'AgreeWithoutVitalAgreed': element.ConsignorData.AgreeWithoutVitalAgreed,
                            'ShipperCompanies': element.ShipperCompanies,
                            'Permissions': element.ConsignorData.Permissions,
                        })
                    });
                    setData(respData);
                })
                .catch(errMsg => notification.error({
                    message: i18n.t('components.notification.titles.getShipperCompaniesList'),
                    description: errMsg
                }))
                .finally(() => setLoadingContentModal(false))
            ;
        }
    }, [isShow, legalEntityId, needUpdate, page, search]);

    const handleSendOrderToShipperCompany = async (shipperCompanyId, parentConsignorId = null) => {
        setCurrentShipperCompanyId(shipperCompanyId);
        try {
            var consignorId = parentConsignorId;
            if (!consignorId) {
                const info = await consignorService.geShipperCompanyInfo(shipperCompanyId);
                if (info) {
                    if (info.Consignor && info.Consignor.Id) consignorId = info.Consignor.Id;
                    else if (typeof info.consignorId !== 'undefined') consignorId = info.consignorId;
                    else if (typeof info.ConsignorId !== 'undefined') consignorId = info.ConsignorId;
                    else if (info.consignor && info.consignor.Id) consignorId = info.consignor.Id;
                }
            }
       
        } catch (e) {
            // ignore and open default flow
        }
        setShowOrderToShipperCompanyModal(true);
    };

    const handleRedirectToOrdersToShipComp = () => {
       
        history.push('/company/orders-to-shipper-company');
    };

    const handleRedirectToOrdersToConsignor = () => {
        const user = userServices.getUser();
        //Этот редирект светится только перевозчикам и грузовладельцам, которые ещё не успели согласоваться как грузовладельцы 
        //Так что всегда должен вести на /company/orders-to-consignor
        //Если логика поменяется можно будет переделать
        history.push('/company/orders-to-consignor');
    };

    const handleSendOrderToConsignor = (consignorId) => {
        setCurrentConsignorId(consignorId);
        setShowOrderToConsignorModal(true);
    };

    const orderToShipperCompanyButtonRender = (record, parentConsignorId) => {
        if (!record.Order) {
            if (!record.Permissions.IsCanCreateOrder) {
                return (
                    <span>{i18n.t('modals.modalListShipCompanies.helpText.3')}</span>
                );
            }

            return (
                <Button onClick={() => handleSendOrderToShipperCompany(record.Id, parentConsignorId)} className="small-button typical-btn-green">
                  {i18n.t('modals.modalListShipCompanies.buttons.sendOrder')}
                </Button>
            );
        } else if (record.Order.Status.Id === 4) {
            return (
                <Button onClick={() => handleRedirectToOrdersToShipComp()} className="small-button typical-btn-green">
                  {i18n.t('modals.modalListShipCompanies.buttons.download')}
                </Button>
            );
        } else {
            return (
                <span>{record.Order.Status.Title}</span>
            );
        }
    };

    const orderToConsignorButtonRender = (record) => {
        if (!record.IsOwner && !record.AgreeWithoutVitalAgreed) {
            return null;

        }

        if (!record.Order) {
            return (
                <Button disabled={!record.Permissions.IsCanCreateOrder} onClick={() => handleSendOrderToConsignor(record.Id)} className="small-button typical-btn-green">
                  {i18n.t('modals.modalListShipCompanies.buttons.create')}
                </Button>
            );
        } else if (record.Order.Status.Id === 3) {
            return (
                <span>
                    {record.Order.Status.Title}
                </span>
            );
        }else {
            return (
                <span>{record.Order.Status.Title}</span>
            );
        }
    };

    const redirectToAdditionalInfoBtnRender = (record) => {
         if (record.Order && record.Order.Status.Id === 3) {
            return (
                <span>
                    <Button onClick={() => handleRedirectToOrdersToConsignor()} className="small-button typical-btn-green">
                        {i18n.t('modals.modalListShipCompanies.buttons.detail')}
                    </Button>
                </span>
            );
        }

         return null;
    }

    const handleClickShowShipperCompanyInfo = (record) => {
        setCurrentShipperCompanyId(record.Id);
        setShowShipperCompanyInfoModal(true);
    }



    const expandedRowRender = (record) => {
        const parentConsignorId = record.Id;
        const columns = [
            { title: i18n.t('modals.modalListShipCompanies.table.name.title'), dataIndex: "Name", key: "Name" },
            { title: i18n.t('modals.modalListShipCompanies.table.status.title'), key: "Id", render: (id, record) => {
                return orderToShipperCompanyButtonRender(record, parentConsignorId);
            } },
            { title: "", key: "", render: (id, record) => {
                    return (
                        <span>
                            <Button onClick={() => handleClickShowShipperCompanyInfo(record)} className="small-button typical-btn-blue">
                                {i18n.t('main.buttons.detail')}
                            </Button>
                        </span>
                    );
                }
            },
        ];
        return <Table columns={columns} dataSource={record.ShipperCompanies} pagination={false} rowKey="Id" />;
    };

    const tableRender = () => {
        const columns = [
            { title: i18n.t('modals.modalListShipCompanies.table.shipper.title'), dataIndex: "Name", key: "Name" },
            { title: "", key: "Id", render: (id, record) => {
                    return orderToConsignorButtonRender(record);
                }
            },
            { title: "", key: "", render: (id, record) => {
                    return redirectToAdditionalInfoBtnRender(record);
                }
            },
        ];

        return <Table columns={columns} dataSource={data} rowKey="Id" expandedRowRender={expandedRowRender} pagination={{current: page, pageSize: perPage, total: total, onChange: (newPage) => setPage(newPage), showSizeChanger: false}} />;
    };

    return(
        <>
            <Modal
                title={i18n.t('modals.modalListShipCompanies.title')}
                cancelText={i18n.t('main.buttons.close')}
                className="modal-window"
                align={null}
                visible={isShow}
                onCancel={() => {
                    setIsShow(false);
                    setPage(1);
                    setSearch('');
                    if (setIsShowParent) {
                        setIsShowParent(false);
                    }
                }}
                footer={null}
            >
                <h4 style={{textAlign: 'center', color: 'black'}}>{helpText}</h4>
                <Input.Search
                    placeholder={i18n.t('modals.modalListShipCompanies.searchPlaceholder')}
                    allowClear
                    onChange={(e) => handleSearchChange(e.target.value)}
                    style={{marginBottom: 16}}
                />
                <Spinner loading={loadingContentModal} label={null}>
                  {tableRender()}
                </Spinner>
            </Modal>

            <OrderInfoModal isShow={showInfoModal} setIsShow={setShowInfoModal} orderId={currentOrderId} />
            <ModalCreateOrderToConsignor setNeedUpdateOrdersList={setNeedUpdate} isShow={showOrderToConsignorModal} setIsShow={setShowOrderToConsignorModal} legalEntityId={legalEntityId} consignorId={currentConsignorId} />
            <ModalShipperCompanyFullInfo shipperCompanyId={currentShipperCompanyId} setIsShow={setShowShipperCompanyInfoModal} isShow={showShipperCompanyInfoModal} />
            <ModalGuarantorBeforeContract
                visible={showGuarantorModal}
                onClose={() => setShowGuarantorModal(false)}
                legalEntityId={legalEntityId}
                onSaved={() => { setShowGuarantorModal(false); setShowOrderToShipperCompanyModal(true); }}
            />
            <ModalCreateContractOrder shipperCompanyID={currentShipperCompanyId} legalEntityID={legalEntityId} isShow={showOrderToShipperCompanyModal} setIsShow={setShowOrderToShipperCompanyModal} />
        </>
    );
}

function OrderInfoModal({isShow, setIsShow, orderId}) {

    const [orderInfoData, setOrderInfoData] = useState({});
    const [loadingContentModal, setLoadingContentModal] = useState(false);

    useEffect(() => {
        if (isShow) {
            setLoadingContentModal(true);
            companyService
                .getOrderInfo(orderId)
                .then(resp => {
                    if (resp.code !== 400) {
                        setOrderInfoData(resp);
                    } else {
                        notification.error({
                            message:  i18n.t('components.notification.titles.getOrderInfo'),
                            description: resp.message,
                        });
                        setIsShow(false);
                    }
                })
                .catch(errMsg => {
                    notification.error({
                        message: i18n.t('components.notification.titles.getOrderInfo'),
                        description: errMsg,
                    });
                    setIsShow(false);
                })
                .finally(() => setLoadingContentModal(false))
            ;
        }
    },[isShow,orderId]);

    const handleResendOrder = () => {
        companyService
            .resendOrder(orderId)
            .then(resp => {
                if (resp.code !== 400) {
                    notification.success({
                        message: i18n.t('components.notification.titles.resendOrder'),
                        description: resp.message,
                    });
                } else {
                    notification.error({
                        message: i18n.t('components.notification.titles.resendOrder'),
                        description: resp.message,
                    });
                }
            })
            .catch(errMsg => {
                notification.error({
                    message: i18n.t('components.notification.titles.resendOrder'),
                    description: errMsg,
                });
                setIsShow(false);
            })
        ;
    };

    return (
        <Modal
          title={i18n.t('modals.modalListShipCompanies.title2')}
          cancelText={i18n.t('main.buttons.close')}
          className="modal-window"
          align={null}
          visible={isShow}
          onCancel={() => {
              setIsShow(false);
          }}
          footer={orderInfoData.refuseReason ? <Button onClick={handleResendOrder} className="small-button typical-btn-green">{i18n.t('modals.modalListShipCompanies.buttons.resend')}</Button> : null}
        >
          <Spinner loading={loadingContentModal} label={null}>
            <Row gutter={[16,24]}>
              <Col sm={8} offset={8}>
                  <p>{i18n.t('modals.modalListShipCompanies.fields.legalEntityName.title')}: {orderInfoData.legalEntityName}</p>
                  <p>{i18n.t('modals.modalListShipCompanies.fields.shipperCompanyName.title')}: {orderInfoData.shipperCompanyName}</p>
                  <p>{i18n.t('modals.modalListShipCompanies.fields.status.title')}: {orderInfoData.status}</p>
                  <p>{i18n.t('modals.modalListShipCompanies.fields.dateCreated.title')}: {orderInfoData.dateCreated}</p>
                  { orderInfoData.refuseReason && (
                      <>
                        <p>{i18n.t('modals.modalListShipCompanies.fields.refuseReason.title')}: {orderInfoData.refuseReason}</p>
                        <p>{i18n.t('modals.modalListShipCompanies.fields.refuseDate.title')}: {orderInfoData.refuseDate}</p>
                      </>
                  )}
              </Col>
            </Row>
          </Spinner>
        </Modal>
    );
}
